import React from 'react';

function AwpIntroText() {
    return(
        <div className="GuideTextPara">
            <h5>Let's dive into becoming an AWPer!</h5>
            <p></p>
        </div>
    )
}

export default AwpIntroText;

// Great awpers can take over games, dominate them and single handily win games. How many times have you seen the likes of Simple and Zywoo by themself win game after game? Never under estimate how much a great awper can impact a team or a game. Besides pure DM abilities, I think there is 4 parts that make a great awper. Knowing your angles, great positioning, awareness and knowing correct timings. Before we hop into these, I want to preface this by saying that knowing the important of these 4 skills and practicing them, perfecting them and continusouly working on them is the difference between average awpers and great awpers.